import api from "@/api/api";

export default {
  data: () => ({
    items: [],
    page: 0,
    size: 10,
    disableLoading: false,
  }),
  methods: {
    async getUserNftCollections() {
      try {
        const response = await api.getUserNftCollections({
          page: this.page++,
          size: this.size,
        });
        response.content.forEach((i) => (i.active = false));
        this.items = [...this.items, ...response.content];
        this.disableLoading = response.content.length < this.size;
      } catch {
        this.disableLoading = true;
      }
    },
    async ownCollectionSearch() {
      try {
        const response = await api.ownCollectionSearch({
          page: this.page++,
          size: this.size,
          search: this.search,
        });
        this.items = [...this.items, ...response.content];
        this.disableLoading = response.content.length < this.size;
      } catch {
        this.disableLoading = true;
      }
    },
  },
};
